export default __webpack_public_path__ + "static/media/portfolio-18.52866504.jpg";